<div class="widget-picker-dialog">
  <div class="dialog-header">
    <h2>{{ stepTitle | translate }}</h2>
    @if (totalSteps > 1) {
      <div class="step-indicator">
        <span class="step" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">1</span>
        <span class="step-line" [class.active]="currentStep > 1"></span>
        <span class="step" [class.active]="currentStep >= 2" [class.completed]="currentStep > 2">2</span>
        <span class="step-line" [class.active]="currentStep > 2"></span>
        <span class="step" [class.active]="currentStep >= 3">3</span>
      </div>
    }
  </div>

  <div class="dialog-content">
    <!-- Step 1: Choose Widget Type -->
    @if (currentStep === 1) {
      <div class="widget-grid">
        @for (widget of availableWidgets; track trackByIndex($index)) {
          <div class="widget-card" (click)="selectWidget(widget)"
            [class.selected]="selectedWidget === widget">
            <div class="widget-card-icon">
              <i class="material-icons">{{ widget.icon }}</i>
            </div>
            <div class="widget-card-name">{{ widget.name | translate }}</div>
            <div class="widget-card-desc">{{ widget.description | translate }}</div>
          </div>
        }
      </div>
    }

    <!-- Step 2: Choose Entity Type -->
    @if (currentStep === 2) {
      <div class="entity-grid">
        @for (entity of entityOptions; track trackByIndex($index)) {
          <div class="entity-card" (click)="selectEntity(entity)"
            [class.selected]="selectedEntity === entity">
            <div class="entity-card-icon">
              <i class="material-icons">{{ entity.icon }}</i>
            </div>
            <div class="entity-card-name">{{ entity.name | translate }}</div>
          </div>
        }
      </div>
    }

    <!-- Step 3: Choose View -->
    @if (currentStep === 3) {
      <div class="view-selection">
        <div class="view-info">
          <p>{{ 'Select a view to display in the widget, or use the default view.' | translate }}</p>
        </div>
        @if (!isLoadingViews) {
          <div class="view-list">
            <div class="view-option default-view" (click)="selectView(null)" [class.selected]="!selectedView">
              <i class="material-icons">auto_awesome</i>
              <span>{{ 'Default View' | translate }}</span>
            </div>
            @for (view of availableViews; track trackById($index, view)) {
              <div class="view-option" (click)="selectView(view)"
                [class.selected]="selectedView?.id === view.id">
                <i class="material-icons">table_view</i>
                <span>{{ view.name }}</span>
              </div>
            }
          </div>
        }
        @if (isLoadingViews) {
          <div class="loading-views">
            <span>{{ 'Loading views...' | translate }}</span>
          </div>
        }
        @if (!isLoadingViews && availableViews.length === 0) {
          <div class="no-views">
            <p>{{ 'No saved views found. The default view will be used.' | translate }}</p>
          </div>
        }
      </div>
    }
  </div>

  <div class="dialog-footer">
    @if (currentStep > 1) {
      <button class="back-btn" (click)="goBack()">
        <i class="material-icons">arrow_back</i>
        {{ 'Back' | translate }}
      </button>
    }
    <div class="spacer"></div>
    <button class="cancel-btn" (click)="close()">{{ 'Cancel' | translate }}</button>
    @if (currentStep === 3) {
      <button class="confirm-btn" (click)="confirm()" [disabled]="!canProceed">
        {{ 'Add Widget' | translate }}
      </button>
    }
  </div>
</div>